import { Platform } from "@angular/cdk/platform";
import { Injectable } from "@angular/core";
import clevertap from "clevertap-web-sdk";

@Injectable({
  providedIn: "root",
})
export class CleverTapService {
  constructor(private readonly platform: Platform) {}
  registerEvent$(eventName: string, eventData: any) {
    // eslint-disable-next-line no-console
    console.log("registerEvent$", eventName, eventData);
    clevertap.event.push(eventName, {
      ...eventData,
      timestamp: new Date().toISOString(),
      device_type: this.platform.isBrowser ? "web" : "mobile",
    });
  }
  registerUser$(data: any) {
    // eslint-disable-next-line no-console
    console.log("onUserLogin$", data);
    clevertap.onUserLogin.push(data);
  }
  registerCleverTapEvent(event: any, body: any) {
    // eslint-disable-next-line no-console
    //console.log('registerCleverTapEvent, my-coupons');
    // eslint-disable-next-line no-console
    //console.log(event, body);
    //this.registerEvent$(event, body);
  }

  registerOnUserLogin(data: any) {
    /*
    this.registerUser$({
      Site: {
        Name: `${data.firstName} ${data.lastName}`,
        Identity: data.identificationNumber,
        Email: data.email,
        Phone: `+${data.countryCode}${data.phoneNumber}`,
        Gender: data.gender === 1 ? 'M' : 'F',
      },
    });
    */
  }
}
